if (document.getElementById("scheduled-at")) {
  jQuery
    .ajax({
      url: location.pathname + ".json",
      method: "GET",
      dataType: "json",
    })
    .then((data) => {
      jQuery("#scheduled-at").text(data.scheduledAt);
    });

  const recommendDfd = jQuery
    .get(location.pathname + "/recommend")
    .then(function (res) {
      $("#recentries-recommend").html(res);
    });

  jQuery.when(recommendDfd).then(function () {
    if (!navigator.userAgent.match(/Macintosh|iPhone|iPad|iOS/i)) {
      FONTPLUS.reload(false);
    }
  });
}
